import { render, staticRenderFns } from "./NolaNovelUpdateConfirm.vue?vue&type=template&id=fd48f44a&scoped=true"
import script from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts"
export * from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelUpdateConfirm.vue?vue&type=style&index=0&id=fd48f44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd48f44a",
  null
  
)

export default component.exports